import { ListItemButton, ListItemIcon, ListItemText, Icon } from '@mui/material';
import '../Navbar.scss';

const AccountMenuItems = ({ title, icon, url, username }) => {
  let urlMod;
  url?.search('USERNAME') > 0 ? (urlMod = url.replace('USERNAME', username)) : (urlMod = url);

  return (
    <ListItemButton component="a" href={urlMod} target="_blank">
      <ListItemIcon>
        <Icon>{icon} </Icon>
      </ListItemIcon>
      <ListItemText primary={title} />
    </ListItemButton>
  );
};

export default AccountMenuItems;
